import { TransactionSearchRequest } from '../../../types';

import { TransactionSearchRequestContextAction } from '../../../types/transactionSearchRequest';
import { TransactionSearchRequestContextActions } from '../actions/transactionSearchRequestContextActions';

function transactionSearchRequestContextReducer(
  state: TransactionSearchRequest,
  action: TransactionSearchRequestContextAction,
): TransactionSearchRequest {
  switch (action.type) {

    case TransactionSearchRequestContextActions.setFormData: {
      return {
        ...state,
        identifier: action.data.identifier,
        email: action.data.email,
        paymentMethod: action.data.paymentMethod,
        transactionDate: action.data.transactionDate,
        amount: action.data.amount,
        currency: action.data.currency,
      };
    }

    case TransactionSearchRequestContextActions.clearAll: {
      return {
        ...state,
        email: '',
        paymentMethod: '',
        transactionDate: '',
        identifier: '',
        currency: '',
        amount: '',
      };
    }

    default: {
      throw new Error(`Unhandled action type: ${JSON.stringify(action)}`);
    }
  }
}

export { transactionSearchRequestContextReducer };
